export default {
  token: (state) => state.app.token,
  siderType: (state) => state.app.siderType,
  lang: (state) => state.app.lang,
  visitedViews: (state) => state.tagsView.visitedViews,
  cachedViews: (state) => state.tagsView.cachedViews,
  region: (state) => state.app.region,
  company: (state) => state.app.company,
  getMenus: (state) => state.app.getMenus,
  routerList: (state) => state.app.routerList,
  loading: (state) => state.app.loading,
  companyList: (state) => state.app.companyList,
  xmitechkey: (state) => state.app.xmitechkey,
  registerRouteFresh: (state) => state.app.registerRouteFresh,
  timeData: (state) => {
    return new Promise((resolve, reject) => {
      resolve(state.app.timeData)
    })
  }
}
